export default __webpack_public_path__ + "static/media/043-not-touch.6cbb5bfc.png";